<template>
  <component :is="modelComponent" :src="src"></component>
</template>

<script>
import {
  ModelStl,
  ModelThree,
  ModelObj,
  ModelPly,
  ModelFbx,
  ModelGltf,
} from "vue-3d-model";

export default {
  name: "View3D",
  components: {
    ModelStl,
    ModelThree,
    ModelObj,
    ModelPly,
    ModelFbx,
    ModelGltf,
  },
  props: {
    src: String,
  },
  computed: {
    modelComponent() {
      const fileExtension = this.src.split(".").pop();

      switch (fileExtension) {
        case "stl":
          return "ModelStl";
        case "json":
          return "ModelThree";
        case "obj":
          return "ModelObj";
        case "ply":
          return "ModelPly";
        case "fbx":
          return "ModelFbx";
        case "gltf":
          return "ModelGltf";
        default:
          return "ModelObj";
      }
    },
  },
};
</script>

<style></style>
